<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de pacientes para atendimento">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-paciente-atendimento/List'

export default {
    components: { List },
}
</script>